import { render, staticRenderFns } from "./ContactTile.vue?vue&type=template&id=befd6762&scoped=true&lang=pug&"
import script from "./ContactTile.vue?vue&type=script&lang=js&"
export * from "./ContactTile.vue?vue&type=script&lang=js&"
import style0 from "./ContactTile.vue?vue&type=style&index=0&id=befd6762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befd6762",
  null
  
)

export default component.exports